<template>
  <div>
    <div>
      <!-- This is the layout for flag groups - these do not have pictures -->
      <!-- Each flag is a two-value radio group with more emphatic text -->
      <div v-for="(e, index) in enums" :key="index">
        <h3 class="blue-text">{{ e.title }}</h3>
        <v-radio-group v-model="e.which" row class="blue-text">
          <v-radio :value="1" v-on:change="setSelection(index, 1)">
            <template slot="label">
              <h4 class="blue-text">Yes</h4>
            </template>
          </v-radio>
          <v-radio :value="0" v-on:change="setSelection(index, 0)">
            <template slot="label">
              <h4 class="blue-text">No</h4>
            </template>
          </v-radio>
          <!--
          <v-radio value="-1" v-on:change="setSelection(index, -1)">
            <template slot="label">
              <h4 class="blue-text">Not sure</h4>
            </template>
          </v-radio>
          -->
        </v-radio-group>
      </div>
    </div>
    <!-- Debug tools -->
    <v-card flat v-if="showTools">
      <v-card-actions>
        <v-btn text @click="applySavedValues">Apply saved values</v-btn>
        <v-btn text @click="clear">Clear</v-btn>
        <v-btn text @click="setTo(1)">To True</v-btn>
        <v-btn text @click="setTo(0)">To false</v-btn>
        <v-card-text>userSet = {{ userSets }};  value = {{ values }}</v-card-text>
      </v-card-actions>
    </v-card>
  </div>
</template>

<style >
@import "../assets/styles/styles.css";
</style>

<script>
export default {
  name: "FlagQuestion",
  props: {
    qid: String,
    showTools: Boolean
  },
  data() {
    return {}
  },
  computed: {
    enums() {
      return this.$store.getters.getChildEnums(this.qid)
    },
    userSets() {
      return this.enums.map(e => e.userSet)
    },
    values() {
      return this.enums.map(e => e.which)
    }
  },
  methods: {
    setSelection(itemIndex, valueIndex) {
      const e = this.enums[itemIndex]
      e.value = valueIndex;
      this.$store.commit("setEnum", { id: e.id, index: valueIndex, userSet: true });
      // If all flags are known, update the UI
      if (this.$store.getters.getQuestionAllUserSet(this.qid)) {
        this.$emit('completed', itemIndex);        
      }
    },
    // Test methods
    applySavedValues() {
      this.$store.commit('applySavedValues', {whichSet: 1})
    },
    clear() {
      this.enums.forEach(e => {
        this.$store.commit("clearEnum", { id: e.id });
      })
    },
    setTo(index) {
      this.enums.forEach(e => {
        this.$store.commit("setEnum", { id: e.id, index: index, userSet: false });
      })
    }
  }
};
</script>
